<template>
  <div>
    <main id="main-menu">
    </main>
    <iframe
      v-if="turnOnSound"
      src="https://s3.amazonaws.com/images.growmindgrow/250-milliseconds-of-silence.mp3"
      allow="autoplay"
      style="display:none"
    >
    </iframe>
    <audio
      v-if="turnOnSound"
      src="https://s3.amazonaws.com/images.growmindgrow/CuteAdventure.mp3"
      autoplay
      loop
    >
    </audio>
  </div>
</template>

<script>

export default {
  name: 'MainMenu',
  computed: {
    turnOnSound() {
      return this.$store.getters.getSoundOn;
    },
  },
  mounted() {
    import('./src/main-menu-init').then((mainMenu) => {
      this.$nextTick(() => { mainMenu.launch(); });
      // eslint-disable-next-line no-restricted-globals
      screen.orientation.lock('landscape');
    });
  },
};
</script>

<style scoped>
    #main-menu {
        display: flex;
        justify-content: center;
        height: 100vh;
    }
</style>
